import { render } from "./Brand.vue?vue&type=template&id=18504597&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=18504597&scoped=true&lang=css"

import exportComponent from "D:\\케이터링\\html(JW 가상화서버)\\justinfood\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18504597"]])

export default __exports__